<template>
  <div id="football_schedule" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>

      <template v-if="unShowSwitchOptFlag">
        <div class="switch_area">
          <base_custom_switch
            :currThemeObj="currThemeObj"
            :data="switchOptArr"
            @clickSwitchEvent="clickSwitch"
          ></base_custom_switch>
        </div>
      </template>
    </div>
    <template v-if="themeItem && matchList && matchList.length > 0">
      <multipleChoiceShare_fixedBtn
        :model="multipleChoiceShareFixedBtn_model"
        :state="multipleChoiceShareFixedBtn_state"
        :modeType="multipleChoiceShareFixedBtn_modeType"
        :smallBtnArr="smallBtnArr"
        :fixedBtn_absTopArr="['18vw', '23.5vw']"
        @changeModelEvent="changeModelEventHandler"
        @clickSmallBtnEvent="clickSmallBtnEventHandler"
        @clickFixedBtnEvent="clickFixedBtnEventHandler"
        :isShow="!noData"
        :changeOptions="multipleChoiceShareFixedBtn_changeOptions"
        @changeTypeEvent="multipleChoiceShareFixedBtn_changeTypeEventHandler"
      ></multipleChoiceShare_fixedBtn>
    </template>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <div
          class="match_label_fixed"
          v-show="curMatchLabelFixedIcon"
          :data="curMatchLabelFixedIcon"
        >
          <div class="match_label">
            <span class="label_textArea">
              <span class="labelIcon" v-if="isShowLabelIcon">
                <img
                  :src="`/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currBigSports.icon}.png`"
                />
              </span>
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
          </div>
        </div>
        <div
          :class="scrollDomClassName"
          ref="scheMatchList_for_locationGroupItem"
        >
          <schedule_group_matchList
            v-for="item in matchList"
            :currCid="currCid"
            :currSid="currSid"
            :key="item.id"
            :currThemeObj="currThemeObj"
            :data="item"
            :pbPx="matchItemPbpx"
            :isShowLabelIcon="isShowLabelIcon"
            :filterCondition="scheduleMatchList_matchMode.filterCondition"
          >
            <template v-slot:matchList>
              <schedule_match_list
                :currCid="currCid"
                :currSid="currSid"
                :currThemeObj="currThemeObj"
                :data="item.list"
                :detailPathName="`scheduleDetailIndex_${currThemeObj.moduleRouteNameEn}`"
                :chooseState="multipleChoiceShareFixedBtn_state"
                :localStorageName="
                  multipleChoiceShareFixedBtn_modeType &&
                  multipleChoiceShareFixedBtn_modeType.localStorageName
                    ? multipleChoiceShareFixedBtn_modeType.localStorageName
                    : ''
                "
                @changeChooseNumEvent="changeChooseNumEventHandler"
                :viewMode="currScheduleMatchList_viewMode"
                @clickMatchItemCheckboxItemEvent="
                  clickMatchItemCheckboxItemEventHandler
                "
                :channelType="currScheduleMatchList_channelType"
                :matchModeObj="scheduleMatchList_matchMode"
                :filterCondition="saveChangeSelectTeamVal"
              />
            </template>
          </schedule_group_matchList>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
        <NOT_DATA :className="'relativePtb60'" v-show="noData" />
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="dialogCancelEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
      :commitBeforeCheckoutCallback="
        multipleChoiceShare_commitBeforeCheckoutCallback
      "
    >
      <template v-slot:checkList>
        <schedule_match_list
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          @changeChooseNumEvent="changeChooseNumEventHandler"
          :viewMode="currScheduleMatchList_viewMode"
          @clickMatchItemCheckboxItemEvent="
            clickMatchItemCheckboxItemEventHandler
          "
          :channelType="currScheduleMatchList_channelType"
          :matchModeObj="scheduleMatchList_matchMode"
        />
      </template>
    </complex_multipleChoiceShare_dialog>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import {
  https_cup_allstage,
  https_cup_stageteammenu,
  https_cup_groupScheduleList,
} from '@api/platfrom_football_api'
import {
  https_basketballCup_allstage,
  https_season_teamList,
  https_basketballCup_groupScheduleList,
} from '@api/platfrom_basketball_api'

import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import base_custom_switch from '@components/base/custom_switch.vue'
import NOT_DATA from '@components/base/NO_DATA.vue'
import BackTop from '@components/base/backTop.vue'
import schedule_group_matchList from '@components/platfromBase/compreSportsMeet/schedule_group_matchList.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'
export default {
  name: 'football_schedule',
  components: {
    marathon_select_opt,
    base_custom_switch,
    schedule_group_matchList,
    schedule_match_list,
    NOT_DATA,
    BackTop,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
  },
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  data() {
    return {
      themeTemplateType: 9,
      isNotDataFlag: false,
      crossSeason: false,
      currScheduleMatchList_viewMode: '',
      themeList: [],
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      unShowSwitchOptCidArr: ['112'],
      basketballCupCidArr: ['202', '203'],
      dynamicStageKeyArr: [],
      switchOptArr: [
        {
          id: 'matchDate',
          name: '按日期查看',
          act: true,
        },
        {
          id: 'stageCode',
          name: '按阶段查看',
          act: false,
        },
      ],
      loading: false,
      isShowLabelIcon: false, //不展示 label上面的图标
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      saveChangeSelectTeamVal: 'team_-1', // badminton_schedule_match_list组件需要，默认值全部
      matchListShowType: 'matchDate', //matchDate | stageCode
      matchLabelArr: [],
      matchList: null,
      matchTotal: 0,
      showBackTop: false,
      currStageEvent: '-1',
      currStageTeam: null,
      stageArr: [],
      teamArr: [],
      selectOptData_origin: {
        configArr: [
          {
            type: 'stage',
            title: '阶段',
            origin_keyVal: ['stageId', 'stageName'], // 源数据list [唯一id, 需要展示文字]
            dataName: 'stageArr', //this下面的存储该数据list字段名
            selectIndex: 0,
          },
          {
            type: 'team',
            title: '球队',
            origin_keyVal: ['teamId', 'teamName'],
            dataName: 'teamArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      channelTv_changeOptions_index: -1,
      currScheduleMatchList_channelType: 'radio',
      matchListViewMode: [
        'scheduleListFootballCup',
        'scheduleNoticeFootballCup',
      ], //这里的字符串相等于唯一id，不能一样；顺序需要可主题列表的顺序一致，否则dom赋值会有问题
      multipleChoiceShareFixedBtn_modeType: null,
      multipleChoiceShareFixedBtn_changeOptions: [], // 分享赛程多个模式时的配置项
      // multipleChoiceShareFixedBtn_modeType: {
      //   btnName: '创建赛程',
      //   localStorageName: 'mixtmt_choose_scheduleListFootballCup',
      //   unit: '场',
      // },
      scheduleMatchList_matchMode: {
        mode: 'FIFAWorldCup',
        type: 'matchDate',
        filterCondition: 'team_-1',
      },
      scheduleMatchList_basketballCup_matchMode: {
        mode: 'BasketballCup',
        type: 'matchDate',
        filterCondition: 'team_-1',
      },
    }
  },
  created() {
    this.query = this.$route.query
    console.debug('route schedule:', this.$route, this.currThemeObj)
    if (this.currGroup) {
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    unShowSwitchOptFlag() {
      let flag = true
      if (this.unShowSwitchOptCidArr.includes(`${this.currCid + ''}`)) {
        flag = false
      }
      return flag
    },
    currBigSports() {
      return {
        label: this.curMatchLabelFixedIcon,
        icon: this.curMatchLabelFixedIcon,
      }
    },
    noMore() {
      // return (
      //   this.matchTotal !== 0 &&
      //   (this.isScrollBottom || this.firstPageIsScrollBottom)
      // )
      console.debug('this.isNotDataFlag:', this.isNotDataFlag)
      return (
        this.matchTotal !== 0 &&
        !this.isNotDataFlag &&
        this.matchList &&
        this.matchList.length > 0
      )
    },
    noData() {
      return this.matchList && this.matchList.length === 0
    },
  },
  methods: {
    async init() {
      // 切换赛季需要重新赋值
      this.currStageEvent = '-1'
      this.currStageTeam = null

      this.initPbPx()
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      console.debug(this.currCid, this.currSid)
      await this.autoChangeViewType()
      console.debug('this.matchList:', this.stageArr, this.matchList)
      this.computedSelectOpt(this.selectOptData.configArr)
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        await this.initFindanalysisItem()
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async themeListAfterMakeMatchList() {
      // 主题获取完后，获取比赛数据，再组装比赛数据，及定位到指定日期比赛
      await this.autoChangeMatchList()
      this.matchList = this.computedMatchList_worldcup(
        this.origin_matchList,
        this.matchListShowType
      )
      const curDateIndex = this.scrollTopCurDate(
        this.matchList,
        this.curDateIndex
      )
      this.$nextTick(() => {
        if (curDateIndex > -1) {
          let curDateDom =
            this.$refs.scheMatchList_for_locationGroupItem.children[
              curDateIndex
            ]
          console.debug(
            'curDateIndex:',
            curDateDom.offsetTop,
            this.$px(8, this.clientWidth)
          )
          this.goBackTop([
            0,
            curDateDom.offsetTop - Math.ceil(this.$px(8, this.clientWidth)),
          ])
        }
      })
    },
    markChanleTv2MatchItem(channelTv_changeOptions_index) {
      // 初始化 matchList 数据，将主题中的频道下拉框数据赋值比赛中
      console.debug(
        'channelTv_changeOptions_index:',
        channelTv_changeOptions_index,
        this.inFilter_channelTvObj
      )
      if (channelTv_changeOptions_index === -1 || !this.inFilter_channelTvObj)
        return
      const channelTv_localStorageName = `mixtmt_choose_${this.matchListViewMode[channelTv_changeOptions_index]}` // 频道主题缓存中的名字
      const chooseObj = this.getLocalStorageChooseObj(
        channelTv_localStorageName
      )
      // console.debug('chooseObj:', chooseObj, channelTv_localStorageName)
      if (
        chooseObj &&
        chooseObj.chooseItemArr &&
        chooseObj.chooseItemArr.length > 0
      ) {
        // 判断缓存中的 channelTvList 是否与当前的 channelTvList 一致，如果不一致取新的，如果一致则取缓存
        let isDiffDataFlag = true //缓存中的数据是否与新的数据一致
        let localStorage_channelTvList = chooseObj.chooseItemArr[0]
          .channelTvList
          ? chooseObj.chooseItemArr[0].channelTvList
          : []
        const new_channelTvList = this.inFilter_channelTvObj.values
        if (localStorage_channelTvList.length !== new_channelTvList.length) {
          // 个数比较
          isDiffDataFlag = false
        }
        if (isDiffDataFlag) {
          let diffIdNum = 0 // 相同value的个数
          localStorage_channelTvList.forEach((localChannelItem) => {
            new_channelTvList.forEach((newChannelItem) => {
              if (newChannelItem.value === localChannelItem.value) {
                diffIdNum++
                if (newChannelItem.name !== localChannelItem.name) {
                  isDiffDataFlag = false
                }
              }
            })
          })
          if (isDiffDataFlag) {
            // 个数虽然相同，然后对比2个数组中它们的value是的都一致
            if (diffIdNum !== localStorage_channelTvList.length) {
              isDiffDataFlag = false
            }
          }
        }
        this.isDiffDataFlag = isDiffDataFlag
      }
      // 因为世界杯球队筛选的过滤是前端做的，因此跟汤尤杯不一致，这里要在 origin_matchList 中赋值频道数组
      const origin_matchList = JSON.parse(JSON.stringify(this.origin_matchList))
      this.origin_matchList = origin_matchList.map((item) => {
        item.channelTvList = JSON.parse(
          JSON.stringify(
            this.inFilter_channelTvObj.values.map((valObj, valIndex) => {
              if (valIndex === 0) {
                valObj.act = true
              } else {
                valObj.act = false
              }
              return valObj
            })
          )
        )
        return item
      })
      console.debug('markChanleTv2MatchItem:', this.origin_matchList)
    },
    multipleChoiceShare_initThemeListCallback(themeList) {
      console.debug('multipleChoiceShare_initThemeListCallback:', themeList)
      if (themeList) {
        // 主题有数据，则走下面
        // 当获取到主题list数据后，将主题中的数据赋值到其他地方
        let changeOptions = []
        this.channelTv_changeOptions_index = -1 //存储频道主题在multipleChoiceShareFixedBtn_changeOptions中的索引
        this.inFilter_channelTvObj = null //切换赛季时需要重新获取主题列表，判断是否有频道
        const matchListViewMode = []
        themeList.forEach((themeItem, themeIndex) => {
          if (themeItem.graphicsId === 39) {
            // 赛程预告
            let type = this.matchListViewMode[1]
            matchListViewMode.push(type)
            changeOptions[themeIndex] = {
              index: themeIndex,
              btnName: themeItem.analysisItemName,
              shortName: '预告',
              type,
              localStorageName: `mixtmt_choose_${type}`,
              unit: '场',
              customkeyArrActJson: {},
            }
            this.channelTv_changeOptions_index = themeIndex
            this.inFilter_channelTvObj = themeItem.inFilter
              ? themeItem.inFilter.filterTypes[0]
              : null
            if (
              this.inFilter_channelTvObj &&
              this.inFilter_channelTvObj.values
            ) {
              this.inFilter_channelTvObj.values.forEach((channelItem) => {
                channelItem.value = channelItem.value + ''
              })
              // this.inFilter_channelTvObj.name => 'channel'
              changeOptions[themeIndex].customkeyArrActJson['actChannelArr'] = {
                // 频道选择，二维数组，最后从缓存数据中组装数据，放到json中的数据，提交创建主题，this.matchList中的单场比赛不需要这个字段
                type: 'Array', //放到json里面字段值类型是数组
                isOnly: false, //是否去重
                keyArr: [this.inFilter_channelTvObj.name, 'actChannelArr'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
              }
            }
          } else if (themeItem.graphicsId === 38) {
            // 比赛列表
            let type = this.matchListViewMode[0]
            matchListViewMode.push(type)
            changeOptions[themeIndex] = {
              index: themeIndex,
              btnName: themeItem.analysisItemName,
              shortName: '比赛',
              type,
              localStorageName: `mixtmt_choose_${type}`,
              unit: '场',
            }
          }
        })
        if (matchListViewMode.length > 0) {
          this.matchListViewMode = matchListViewMode //按照主题列表，重置顺序
        }
        console.debug(
          'changeOptions:',
          changeOptions,
          this.inFilter_channelTvObj
        )
        this.multipleChoiceShareFixedBtn_changeOptions = changeOptions
        this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(0)
      }

      // 有没有数据都需要获取及组装比赛数据
      this.themeListAfterMakeMatchList()
    },
    multipleChoiceShareFixedBtn_changeScheduleMatchListView(actIndex) {
      this.multipleChoiceShareFixedBtn_modeType =
        this.multipleChoiceShareFixedBtn_changeOptions[actIndex]
      this.currScheduleMatchList_viewMode = this.matchListViewMode[actIndex]
    },
    multipleChoiceShareFixedBtn_changeTypeEventHandler(data) {
      if (data) {
        let multipleChoiceShareFixedBtn_modeType = null
        if (data.type === 'rect') {
          // 分享赛程切换模式时执行的函数，支持2或大于2个以上的选项切换
          let actIndex =
            data.modeType.index + 1 >=
            this.multipleChoiceShareFixedBtn_changeOptions.length
              ? 0
              : data.modeType.index + 1
          this.multipleChoiceShareFixedBtn_changeOptions.forEach(
            (opts, optIndex) => {
              if (opts.type !== data.modeType.type && actIndex === optIndex) {
                this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
                  optIndex
                )
                this.themeItem = this.formatThemeListArr[optIndex]
              }
            }
          )
        } else if (data.type === 'circular') {
          // 圆型时传来的就是选中的主题
          let actIndex = data.modeType.index
          this.multipleChoiceShareFixedBtn_changeOptions.forEach(
            (opts, optIndex) => {
              if (opts.type === data.modeType.type && actIndex === optIndex) {
                this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
                  optIndex
                )
                this.themeItem = this.formatThemeListArr[optIndex]
              }
            }
          )
        }
        this.isClearlearLocalStorageChoose()
      }
    },
    multipleChoiceShare_commitBeforeCheckoutCallback(
      multipleChoiceShareFixedBtn_modeType
    ) {
      console.debug(
        'multipleChoiceShareFixedBtn_modeType:',
        multipleChoiceShareFixedBtn_modeType
      )
      let isCheckoutFlag = true
      let errorTipText = ''
      if (
        this.channelTv_changeOptions_index > -1 &&
        multipleChoiceShareFixedBtn_modeType.type ===
          this.matchListViewMode[this.channelTv_changeOptions_index]
      ) {
        // 频道预告需要验证
        for (let i = 0; i < this.matchList.length; i++) {
          const matchItem = this.matchList[i]
          if (matchItem.isChooseFlag && matchItem.channelTvList) {
            // 比赛被选中且频道数组中没有元素时，不能创建，提示未选择频道
            let isActChooce = false
            matchItem.channelTvList.forEach((channelItem) => {
              if (channelItem.act) {
                isActChooce = true
              }
            })

            if (!isActChooce) {
              // 如果 isActChooce 没有为 true 则证明选中的比赛中有没有选中的频道，所以为 false；因此验证不通过，跳出循环
              isCheckoutFlag = false
              break
            }
          }
        }
        errorTipText = '分享的比赛中存在【未选择频道】的比赛'
      }
      console.debug('this.matchList:', this.matchList)
      if (isCheckoutFlag) {
        // 验证通过，直接组装缓存数据中的 actChannelArr 数据，创建的时候是从缓存中取数据的
        let chooseObj = this.getLocalStorageChooseObj(
          multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        chooseObj.chooseIdArr.forEach((chooseId) => {
          let actChannelArr = []
          chooseObj.chooseItemArr.forEach((chooseItem) => {
            if (chooseItem.chooseId === chooseId && chooseItem.channelTvList) {
              chooseItem.channelTvList.forEach((channelItem) => {
                if (channelItem.act) {
                  actChannelArr.push(channelItem.value)
                }
              })
              chooseItem.actChannelArr = actChannelArr
            }
          })
        })
        this.$localStorage.setItem(
          multipleChoiceShareFixedBtn_modeType.localStorageName,
          JSON.stringify(chooseObj)
        )
      }
      return { isCheckoutFlag, errorTipText }
    },
    updateLocalStorageHandler(localStorageName, matchItem, actItem, type) {
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let chooseObj = this.$localStorage.getItem(localStorageName)
        ? JSON.parse(this.$localStorage.getItem(localStorageName))
        : {
            cid: this.currCid,
            // date: this.localStorageSaveDate,
            chooseItemArr: [],
            chooseIdArr: [],
          }
      if (chooseObj.cid === this.currCid) {
        if (chooseObj.chooseItemArr.length === 0) {
          // 因为只是点击频道选择，执行此函数证明，缓存中有数据，所以不会走到这里
          // this.matchList.forEach((matchItem) => {
          //   if (matchItem.isChooseFlag) {
          //     chooseObj.chooseItemArr.push(matchItem)
          //     chooseObj.chooseIdArr.push(matchItem.chooseId)
          //   }
          // })
        } else {
          // 这里是缓存中的数据，已经是被选中的比赛了，所以不用再判断是否被选中了
          if (type) {
            if (type === 'checkbox') {
              // 多选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = !channleItem.act
                    }
                  })
                }
              })
            } else if (type === 'radio') {
              // 单选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = true
                    } else {
                      channleItem.act = false
                    }
                  })
                }
              })
            }
          }
        }
        this.$localStorage.setItem(localStorageName, JSON.stringify(chooseObj))
        this.localStorageChooseList = chooseObj.chooseItemArr
        console.debug('chooseObj:', chooseObj)
      } else {
        console.error('错误：赛事不同')
      }
    },
    clickMatchItemCheckboxItemEventHandler(data) {
      // cba单选， 亚运会多选
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let isUpdateLocalStroge = false
      let { matchItem, actItem, type } = data
      console.debug('clickMatchItemCheckboxItemEventHandler:', type)
      let matchList = JSON.parse(JSON.stringify(this.matchList))
      if (type === 'checkbox') {
        // 多选逻辑
        matchList.forEach((group) => {
          group.list.forEach((match) => {
            if (match.chooseId === matchItem.chooseId) {
              match.channelTvList.forEach((channleItem) => {
                if (channleItem.value === actItem.value) {
                  channleItem.act = !channleItem.act
                }
              })
              if (match.isChooseFlag) {
                isUpdateLocalStroge = true
              }
            }
          })
        })
      } else if (type === 'radio') {
        // 单选逻辑
        matchList.forEach((group) => {
          group.list.forEach((match) => {
            if (match.chooseId === matchItem.chooseId) {
              match.channelTvList.forEach((channleItem) => {
                if (channleItem.value === actItem.value) {
                  channleItem.act = true
                } else {
                  channleItem.act = false
                }
              })
              if (match.isChooseFlag) {
                isUpdateLocalStroge = true
              }
            }
          })
        })
      }
      this.matchList = matchList
      if (isUpdateLocalStroge) {
        // 如果该比赛被选中，则需要将频道数据同步到缓存中，否则不需要同步缓存数据;
        // 由于缓存中可能会存储多天的比赛数据，所以不能再matchList中将被选中的数据替换到缓存中
        this.updateLocalStorageHandler(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName,
          matchItem,
          actItem,
          this.currScheduleMatchList_channelType
        )
      }
    },
    changeChooseNumEventHandler(data) {
      // 这个是多选分享每个.vue文件根据数据结构，单独写的
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        // multipleChoiceShare_fixedBtn 组件清除缓存数据时，源数据是否要重置
        this.matchList.forEach((group) => {
          if (group.list) {
            group.list.forEach((match) => {
              match.isChooseFlag = false
              if (
                this.channelTv_changeOptions_index > -1 &&
                data.type ===
                  this.matchListViewMode[this.channelTv_changeOptions_index]
              ) {
                // 频道预告
                if (match.channelTvList) {
                  const channelTvList = JSON.parse(
                    JSON.stringify(match.channelTvList)
                  )
                  channelTvList.forEach((item, itemIndex) => {
                    if (itemIndex === 0) {
                      item.act = true
                    } else {
                      item.act = false
                    }
                  })
                  match.channelTvList = channelTvList
                }
              }
            })
          }
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        console.debug('data.type:', data, chooseSchedule)
        let matchList = JSON.parse(JSON.stringify(this.matchList))
        matchList.forEach((group) => {
          if (group.list) {
            group.list.forEach((item) => {
              if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
                item.isChooseFlag = true
                // 只有多选的才会 data.type
                if (
                  this.channelTv_changeOptions_index > -1 &&
                  data.type ===
                    this.matchListViewMode[this.channelTv_changeOptions_index]
                ) {
                  // 赛程预告
                  chooseSchedule.chooseItemArr.forEach((chooseItem) => {
                    if (chooseItem.chooseId === item.chooseId) {
                      if (this.isDiffDataFlag) {
                        // 数据一致
                        item.channelTvList = chooseItem.channelTvList
                        console.debug('chooseItem:', chooseItem)
                      } else {
                        // 数据不一致，全部保持数据初始化状态
                      }
                    }
                  })
                }
              } else {
                item.isChooseFlag = false
              }
            })
          }
        })
        this.matchList = matchList
        this.$localStorage.setItem(
          data.localStorageName,
          JSON.stringify(chooseSchedule)
        )
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    goBackTop(valArr) {
      const points = valArr ? valArr : [0, 0]
      if (this.scrollAreaDom) {
        console.debug('goBackTop:', points)
        this.scrollAreaDom.scrollTo(points[0], points[1])
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }

      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)
      // console.debug('addEventListener:', this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })

      this.initScrollToCurDate() //跳到当前日期赛程下
    },
    scrollListenerEvent() {
      // console.debug('scrollListenerEvent')
      const scrollTop = this.scrollAreaDom.scrollTop
      // const scrollHeight = this.scrollAreaDom.scrollHeight
      // const parentHeightPx = this.scrollAreaDom.offsetHeight
      // let direction = this.DIRECTION_ENUM.DOWN
      // if (this.beforeScrollTop > scrollTop) {
      //   direction = this.DIRECTION_ENUM.UP
      // }

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      // multipleChoiceShare_fixedBtn 需要
      this.scrollChangeHandler(scrollTop)

      // this.changeMatchLabelFixed(scrollTop, direction)
      // if (direction == this.DIRECTION_ENUM.DOWN) {
      //   // 滚动触底
      //   if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
      //     console.debug('滚动触底')
      //     this.isScrollBottom = true
      //   }
      // } else {
      //   // 滚动到顶部
      //   this.isScrollBottom = false
      //   if (scrollTop <= this.threshold) {
      //     console.debug('滚动到顶部')
      //   }
      // }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    initScrollToCurDate() {
      const curDateIndex = this.scrollTopCurDate(
        this.matchList,
        this.curDateIndex
      )
      console.debug(
        'initScrollToCurDate',
        curDateIndex,
        this.curDateIndex,
        this.matchList
      )
      this.$nextTick(() => {
        if (curDateIndex > -1) {
          let curDateDom =
            this.$refs.scheMatchList_for_locationGroupItem.children[
              curDateIndex
            ]
          console.debug(
            'curDateIndex:',
            curDateDom.offsetTop,
            this.$px(8, this.clientWidth)
          )
          this.goBackTop([
            0,
            curDateDom.offsetTop - Math.ceil(this.$px(8, this.clientWidth)),
          ])
        }
      })
    },
    scrollTopCurDate(arr, curDate) {
      // curDate格式：'2022-11-26'
      let curIndex = -1
      if (curDate) {
        arr.forEach((item, index) => {
          if (curDate == item.icon) {
            curIndex = index
          }
        })
      }
      console.debug('scrollTopCurDate:', curIndex)
      return curIndex
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }

      if (this.matchTotal > 0) {
        this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
      }
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含 paddingBottom 值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      this.curHeightPx = curHeightPx
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
      console.debug('this.matchItemPbpx:', this.matchItemPbpx)
    },
    onResizeEvent() {
      this.initPbPx()
      // if (this.$refs.tableParentDom) {
      //   this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // } else {
      //   console.debug('dom 不存在')
      // }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    clickSwitch(item) {
      this.switchOptArr.forEach((switchItem) => {
        if (switchItem.id == item.id) {
          switchItem.act = true
        } else {
          switchItem.act = false
        }
      })
      this.matchListShowType = item.id
      let scheduleMatchList_matchMode = JSON.parse(
        JSON.stringify(this.scheduleMatchList_matchMode)
      )
      scheduleMatchList_matchMode.type = this.matchListShowType
      this.scheduleMatchList_matchMode = scheduleMatchList_matchMode
      this.matchList = this.computedMatchList_worldcup(
        this.origin_matchList,
        this.matchListShowType,
        this.saveChangeSelectTeamVal
      )
    },
    async changeSelect(data) {
      console.debug('changeSelect:', data)
      let valPathArr = []
      let val = data.val
      let filterTeamAfterHasMatchItemFlag = true //false：球队过滤后没有比赛了；true：球队过滤后还有比赛
      // 选择后，重置联动的筛选框
      let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'stage') {
            // 默认是日期形式展示比赛列表
            this.matchListShowType = 'matchDate'
            this.scheduleMatchList_matchMode.type = this.matchListShowType
            this.switchOptArr.forEach((switchItem) => {
              if (switchItem.id == this.matchListShowType) {
                switchItem.act = true
              } else {
                switchItem.act = false
              }
            })
            this.currStageEvent = valPathArr[1]
            window.mixtmtBase_eventBus.$emit('loadingEvent', true)
            await this.autoChangeMatchList()
          } else if (valPathArr[0] === 'team') {
            this.saveChangeSelectTeamVal = val
          }
          if (this.saveChangeSelectTeamVal === 'team_-1') {
            filterTeamAfterHasMatchItemFlag = true
          } else {
            let isHasMatchIdFlag = false
            this.origin_matchList.forEach((matchItem) => {
              if (
                [`${matchItem.homeId}`, `${matchItem.awayId}`].includes(
                  this.saveChangeSelectTeamVal.split('_')[1]
                )
              ) {
                isHasMatchIdFlag = true
              }
            })
            filterTeamAfterHasMatchItemFlag = isHasMatchIdFlag
          }
          if (val && val.indexOf('_') > -1) {
            let scheduleMatchList_matchMode = JSON.parse(
              JSON.stringify(this.scheduleMatchList_matchMode)
            )
            scheduleMatchList_matchMode.filterCondition =
              this.saveChangeSelectTeamVal
            this.scheduleMatchList_matchMode = scheduleMatchList_matchMode
          }

          if (
            filterTeamAfterHasMatchItemFlag &&
            this.origin_matchList &&
            this.origin_matchList.length > 0
          ) {
            // 过滤后有比赛了
            this.isNotDataFlag = false
          } else if (!filterTeamAfterHasMatchItemFlag) {
            // 过滤后没有比赛了，暂无数据
            this.isNotDataFlag = true
          } else {
          }
          // 筛选赛程列表逻辑
          this.matchList = this.computedMatchList_worldcup(
            this.origin_matchList,
            this.matchListShowType,
            this.saveChangeSelectTeamVal
          )
          console.debug(
            '筛选赛程列表逻辑',
            this.saveChangeSelectTeamVal,
            this.matchListShowType,
            val,
            this.origin_matchList,
            this.matchList,
            this.scheduleMatchList_matchMode,
            filterTeamAfterHasMatchItemFlag,
            valPathArr[1]
          )
          window.mixtmtBase_eventBus.$emit('loadingEvent', false)
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    computedMatchList_worldcup(arr, type, select) {
      // 足球世界杯 || 篮球杯赛 组装赛程
      // 切换展示状态，组装不同的赛程列表数据
      let sortGroupKey = []
      console.debug('computedMatchList_worldcup:', select, type)
      let labelArr = []
      if (!type) {
        type = 'matchDate'
      }
      // 小组赛阶段对应的Id
      let groupKey = 'GS'
      // 小组赛中A|B取这个字段
      let dynamicSeriesKeyArr = ['seriesCode', 'seriesWeekName']
      // 阶段取这个字段
      let dynamicStageKeyArr = this.dynamicStageKeyArr
      arr.forEach((item) => {
        let labelId = ''
        if (type === 'matchDate') {
          labelId = `matchDate+${item[type]}`
        } else if (type === 'stageCode') {
          labelId = `${item[dynamicStageKeyArr[0]]}+${
            item[dynamicSeriesKeyArr[0]]
              ? item[dynamicSeriesKeyArr[0]]
              : item[dynamicStageKeyArr[0]]
          }`
        }
        if (labelArr.length == 0 || !labelArr.includes(labelId)) {
          labelArr.push(labelId)
          if (type == 'stageCode') {
            // 阶段的排序规则
            sortGroupKey.push({
              id: labelId,
              name:
                groupKey === item[dynamicStageKeyArr[0]]
                  ? item[dynamicSeriesKeyArr[1]]
                  : item[dynamicStageKeyArr[1]],
            })
          }
        }
      })
      console.debug('labelArr:', labelArr, sortGroupKey)
      let matchList = []
      labelArr.forEach((typeItem) => {
        let obj = {
          id: typeItem,
          label: '',
          icon: typeItem.split('+')[1],
          list: [],
        }
        arr.forEach((item) => {
          if (!item.weekCN) {
            // 获取新数据时组装数据
            let matchDate = item.matchDatetime.split(' ')[0]
            if (item.matchDatetime && item.matchDatetime.indexOf('T') > 0) {
              matchDate = item.matchDatetime.split('T')[0]
            } else if (
              item.matchDatetime &&
              item.matchDatetime.indexOf(' ') > 0
            ) {
              matchDate = item.matchDatetime.split(' ')[0]
            }
            let week = '星期' + this.getWeekCN(matchDate)
            let dateArr = matchDate.split('-')
            let weekCN = ''
            if (dateArr.length == 3) {
              weekCN = `${dateArr[1]}月${dateArr[2]}日 ${week}`
            }
            item.weekCN = weekCN
            if (!item.joinPointFlag) {
              item.joinPointFlag = false
            }
            if (
              !item.joinPointFlag &&
              (item.homePoint !== null || item.awayPoint !== null) &&
              !this.basketballCupCidArr.includes(this.currCid)
            ) {
              item.joinPointFlag = true
              item.homeScore = item.homeScore
              item.homeScore = `${item.homeScore}(${item.homePoint})`
              item.awayScore = item.awayScore
              item.awayScore = `${item.awayScore}(${item.awayPoint})`
            }

            if (item[dynamicStageKeyArr[0]] === groupKey) {
              // 小组赛
              item.stageCodeWeb = item[dynamicSeriesKeyArr[0]]
              item.stageNameWeb = item[dynamicSeriesKeyArr[1]]
            } else {
              // 非小组赛
              item.stageCodeWeb = item[dynamicStageKeyArr[0]]
              item.stageNameWeb = item[dynamicStageKeyArr[1]]
            }
            item.chooseId = item.matchId
            item.isChooseFlag = false
          }

          let typeItemArr = typeItem.split('+')
          let stageCode = typeItemArr[0]
          let seriesCode = typeItemArr[1]

          if (
            (type == 'matchDate' && seriesCode === item[type]) ||
            (groupKey === item[dynamicStageKeyArr[0]] &&
              seriesCode === item[dynamicSeriesKeyArr[0]] &&
              stageCode !== seriesCode) ||
            (groupKey !== item[dynamicStageKeyArr[0]] &&
              stageCode === item[dynamicStageKeyArr[0]] &&
              stageCode === seriesCode)
          ) {
            // 第一个判断小组赛赛段，第二个判断非小组赛赛段
            if (!obj.label) {
              if (type == 'matchDate') {
                // 按日期展示
                obj.label = item.weekCN
              } else if (type === 'stageCode') {
                // 按阶段展示
                let label = ''
                if (sortGroupKey) {
                  sortGroupKey.forEach((pItem) => {
                    if (pItem.id === typeItem) {
                      label = pItem.name
                    }
                  })
                }
                obj.label = label
              }
            }
            if (select && select.indexOf('_') > -1) {
              const selectArr = select.split('_')
              // console.debug(selectArr)
              if (
                selectArr[0] == 'team' &&
                [`${item.homeId}`, `${item.awayId}`, '-1', ''].includes(
                  selectArr[1]
                )
              ) {
                console.debug(
                  '该页面只有球队筛选走这里，因为阶段切换样式，所以可以不走这里',
                  selectArr[1]
                )
                obj.list.push(item)
              } else if (selectArr[0] == 'stage' && selectArr[1] == '1') {
                obj.list.push(item)
              }
            } else {
              console.debug('非筛选情况下走这里')
              obj.list.push(item)
            }
          }
        })
        // console.debug('obj:', obj)
        if (obj.list && obj.list.length > 0) {
          matchList.push(obj)
        }
      })
      console.debug('matchList:', matchList)
      if (sortGroupKey) {
        // 由于后端返回的数据都是按日期排序排好的，所以小组赛时同一个时间的，后端没有按照字母顺序排序,因此需要对字母sort一次；淘汰赛暂时不需要再次排序，因为都是一个阶段接一个阶段，没有同时出现2个阶段的情况
        const groupMatchList = [] //小组赛 组比赛
        const knockoutMatchList = [] // 淘汰赛 组比赛

        matchList.forEach((group) => {
          if (group.id.indexOf(`${groupKey}+`) > -1) {
            groupMatchList.push(group)
          } else {
            knockoutMatchList.push(group)
          }
        })
        groupMatchList.sort((a, b) => a.icon.localeCompare(b.icon))

        matchList = [].concat(groupMatchList, knockoutMatchList)
      }
      return matchList
    },
    async getParstage() {
      await https_cup_allstage(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const stageArr = res.data && res.data.length > 0 ? res.data : []
            this.stageArr = [].concat(
              [
                {
                  stageId: '-1',
                  stageName: '全部',
                },
              ],
              stageArr
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getStageTeam() {
      await https_cup_stageteammenu(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.teamArr = res.data ? res.data : []
            this.teamArr.unshift({
              teamId: '-1',
              teamName: '全部球队',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getScheduleMatchList() {
      const stage = this.currStageEvent === '-1' ? '' : this.currStageEvent
      if (this.isNotDataFlag) {
        this.isNotDataFlag = false
      }
      await https_cup_groupScheduleList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
        stage,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (
              !res.data ||
              (res.data && res.data.group && res.data.group.length == 0)
            ) {
              this.isNotDataFlag = true
            }

            this.curDateIndex = res.data && res.data.date ? res.data.date : null
            this.origin_matchList =
              res.data && res.data.group ? res.data.group : []

            this.matchTotal = this.origin_matchList.length //res.data.length

            if (this.scrollAreaDom) {
              this.scrollAreaDom.scrollTo(0, 0)
            }
            if (this.matchTotal === 0) {
              // 初始化访问结果为暂无数据
              this.matchList = []
            }
            this.matchLabelArr = []
            this.curMatchLabelFixedIcon = null
            this.initScroll()
            // if (stage == 1) {
            //   this.curDateIndex =
            //     res.data && res.data.date ? res.data.date : null
            //   this.origin_matchList =
            //     res.data && res.data.group ? res.data.group : []

            //   this.matchTotal = this.origin_matchList.length //res.data.length

            //   if (this.scrollAreaDom) {
            //     this.scrollAreaDom.scrollTo(0, 0)
            //   }
            //   this.matchList = []
            //   this.matchLabelArr = []
            //   this.curMatchLabelFixedIcon = null
            //   this.initScroll()
            // } else {
            //   this.origin_knockoutList = res.data
            //     ? { data: { dataList: res.data } }
            //     : { data: { dataList: [] } }
            // }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      this.markChanleTv2MatchItem(this.channelTv_changeOptions_index)
    },
    async autoChangeMatchList() {
      if (this.basketballCupCidArr.includes(this.currCid)) {
        await this.getBasketballCupScheduleMatchList()
      } else {
        // 足球杯赛
        await this.getScheduleMatchList()
      }
    },
    async autoChangeViewType() {
      if (this.basketballCupCidArr.includes(this.currCid)) {
        // 篮球杯赛
        this.scheduleMatchList_matchMode =
          this.scheduleMatchList_basketballCup_matchMode
        this.dynamicStageKeyArr = ['stageCode', 'stageName']
        this.matchListViewMode = [
          'scheduleListBasketballCup',
          'scheduleNoticeBasketballCup',
        ]
        await this.getbasketballCupPhaseStage()
        await this.getStageTeamList()
        await this.getBasketballCupScheduleMatchList()
      } else {
        // 足球杯赛
        this.dynamicStageKeyArr = ['stageId', 'stageName']
        await this.getParstage()
        await this.getStageTeam()
        await this.getScheduleMatchList()
      }
    },
    async getbasketballCupPhaseStage() {
      await https_basketballCup_allstage(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const stageArr =
              res.data && res.data.length > 0
                ? res.data.map((item) => {
                    return {
                      stageId: item.phaseId,
                      stageName: item.phaseName,
                    }
                  })
                : []
            this.stageArr = [].concat(
              [
                {
                  stageId: '-1',
                  stageName: '全部',
                },
              ],
              stageArr
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getStageTeamList() {
      await https_season_teamList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.teamArr = res.data ? res.data : []
            this.teamArr.unshift({
              teamId: '-1',
              teamName: '全部球队',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBasketballCupScheduleMatchList() {
      const stage = this.currStageEvent === '-1' ? '' : this.currStageEvent
      if (this.isNotDataFlag) {
        this.isNotDataFlag = false
      }
      await https_basketballCup_groupScheduleList(
        this.axiosBaseUrl,
        this.$axios,
        {
          sid: this.currSid,
          cid: this.currCid,
          stage,
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (
              !res.data ||
              (res.data && res.data.group && res.data.group.length == 0)
            ) {
              this.isNotDataFlag = true
            }

            this.curDateIndex = res.data && res.data.date ? res.data.date : null
            this.origin_matchList =
              res.data && res.data.group ? res.data.group : []

            this.matchTotal = this.origin_matchList.length //res.data.length

            if (this.scrollAreaDom) {
              this.scrollAreaDom.scrollTo(0, 0)
            }
            if (this.matchTotal === 0) {
              // 初次访问结果为暂无数据
              this.matchList = []
            }
            this.matchLabelArr = []
            this.curMatchLabelFixedIcon = null
            this.initScroll()
            // if (stage == 1) {
            //   this.curDateIndex =
            //     res.data && res.data.date ? res.data.date : null
            //   this.origin_matchList =
            //     res.data && res.data.group ? res.data.group : []

            //   this.matchTotal = this.origin_matchList.length //res.data.length

            //   if (this.scrollAreaDom) {
            //     this.scrollAreaDom.scrollTo(0, 0)
            //   }
            //   this.matchList = []
            //   this.matchLabelArr = []
            //   this.curMatchLabelFixedIcon = null
            //   this.initScroll()
            // } else {
            //   this.origin_knockoutList = res.data
            //     ? { data: { dataList: res.data } }
            //     : { data: { dataList: [] } }
            // }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      this.markChanleTv2MatchItem(this.channelTv_changeOptions_index)
    },
    // async getStageTeamList() {
    //   await https_season_teamList(this.axiosBaseUrl, this.$axios, {
    //     sid: this.currStageSeason,
    //   })
    //     .then((response) => {
    //       const res = response.data
    //       if (res.status === 0) {
    //         const teamArr = res.data
    //           ? res.data.map((item) => {
    //               return {
    //                 value: item.teamId,
    //                 name: item.teamName,
    //               }
    //             })
    //           : []
    //         this.teamArr = [].concat(
    //           JSON.parse(JSON.stringify(this.selectAllObj)),
    //           teamArr
    //         )
    //         if (this.teamArr.length > 0) {
    //           this.currStageTeam = this.teamArr[0].value
    //         }
    //         console.debug('getStageTeamList:', this.teamArr)
    //       } else {
    //         if (res.message) {
    //           // message：null，因此不弹出警示框（一般404 || 500的时候）；
    //           // message不为null的时候展示警示框；
    //           this.$message({
    //             showClose: true,
    //             message: res.message ? res.message : '服务器异常，请稍后再试',
    //             type: 'warning',
    //           })
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.debug(err)
    //     })
    // },
  },
}
</script>

<style lang="scss" scoped>
#football_schedule {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            width: 21.55%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 2.778vw;
              height: 2.778vw;
              border: 1.5px solid var(--mixtmt_whiteColor);
              border-radius: 50%;
              overflow: hidden;
              margin-right: 0.694vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
        }
      }
      /* .scrollDomContain {
          max-height: calc(100vh - 19.142vw);
          overflow: auto;
        } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
